import React from "react";
export var ModalDialogCommon = React.createClass({
  render() {
    var style = {
      marginLeft: "10px",
    };
    return (
      <div
        id="new-facility"
        className="modal fade in"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-content-text create-facility-modal ">
          <div className="modal-box">
            <div className="modal-dialog">
              <div className="modal-content text-center">
                <div>{this.props.message}</div>
                {this.props.children}
                <button className="gray-button" onClick={this.props.action}>
                  OK
                </button>
                {this.props.cancel === "true" ? (
                  <button
                    style={style}
                    autoFocus
                    className="gray-button"
                    onClick={this.props.action2}
                  >
                    Cancel
                  </button>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
});
//autoFocus={this.props.cancel === "true" ? false:true}



/** WEBPACK FOOTER **
 ** ./src/components/modal_dialog_common.jsx
 **/